module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.staffName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.fillDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("出差人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.outPeoplesName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("出差人职务")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.outPeoplesJob))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("申请信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("代理人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.proxyStaffName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("代理人职务")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.proxyStaffJob))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("出差事由")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.outReason))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("开始时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.startTime))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("结束时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.endTime))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("出差天数")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.outDays))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("交通工具")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.vehicle))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("出差地点")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.address))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("预计出差费用")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-button', {
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showImg(1)
      }
    }
  }, [_vm._v("查看")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("合计（元）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.total))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("合计大写")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.bigTotal))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("预支金额（元）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.planMoney))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("预支大写")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.bigPlanMoney))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("备注")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.remark))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5966426e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/todo/attendance/businessTrip.vue
// module id = IADS
// module chunks = 1